<template>
    <div class="subPage">
        <div class="model filterContent">
            <!-- 头部信息栏 -->
            <Header :property="property" :withDrawValue="withDrawValue" :changeWithDrawValue="changeWithDrawValue" />
            <!-- 二维码区 -->
            <WithDrawCode :property="property" :withDrawAll="withDrawAll" :qrocodes="qrocodes" :withDrawValue="withDrawValue" />
            <br />
        </div>
        <!-- 提现记录 -->
        <WithDrawRecord :payStatus="payStatus" :withDrawList="withDrawList" />
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userWithDrawElement/Header';
import WithDrawCode from '../userWithDrawElement/WithDrawCode';
import WithDrawRecord from '../userWithDrawElement/WithDrawRecord';

export default {
  name: 'WithDraw',
  meta:{page:true},
  computed: {
    ...mapGetters('userinterface', {
      payStatus: 'getPayStatus',
    }),
    ...mapGetters('user', {
      withDrawList: 'getWithDrawList',
      property: 'getProperty',
      qrocodes: 'getQrocodes',
    }),
  },
  data() {
    return {
      withDrawValue: 0,
    };
  },
  methods: {
    withDrawAll: function() {
      this.withDrawValue = this.property.usable / 100;
    },
    changeWithDrawValue: function(val) {
      this.withDrawValue = val;
      // this.withDrawValue = e.target.value.replace(/\.{2,}/g,".");
    },
  },
  components: {
    Header,
    WithDrawCode,
    WithDrawRecord,
  },
  created() {
    this.$store.dispatch('user/getWithDrawList');
    this.$store.dispatch('user/getProfitAcceptQrcode');
    this.$store.dispatch('user/getUserProFit');
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterContent {
  height: fit-content;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page/WithDraw.vue